import header from "./gebaeude-vermessung-laser-innenraum.webp";
import section1 from "./dummy.png";
import section2 from "./gebaeude-vermessung-massband-laser.webp";
import section3 from "./dummy.png";
import section4 from "./dummy.png";
import section5 from "./gebaeude-vermessung-cad-software.webp";
import section6 from "./dummy.png";
import section7 from "./dummy.png";
import section8 from "./gebaeude-vermessung-grundriss-bank.webp";
import section9 from "./dummy.png";

export {
  header,
  section1,
  section2,
  section3,
  section4,
  section5,
  section6,
  section7,
  section8,
  section9,
};
